import { useMutation } from '@tanstack/react-query';
import { FileApi } from 'api';
import type { Upload, Download } from 'api/methods/FileApi';

/**
 * [File] 파일 업로드
 * --
 */
export const useFileUpload = () => {
  const { mutateAsync: fileUpload, ...result } = useMutation({
    mutationFn: (variables: Upload) => FileApi.uploadFile(variables),
  });

  return { fileUpload, ...result };
};

/**
 * [File] 파일 배열 업로드
 * --
 */
export const useFileMultiUpload = () => {
  const { mutateAsync: fileUpload, ...result } = useMutation({
    mutationFn: (variables: Upload[]) => FileApi.uploadFileMulti(variables),
  });

  return { fileUpload, ...result };
};

/**
 * [File] 파일 다운로드
 * --
 */
export const useFileDownload = () => {
  const { mutateAsync: fileDownload, ...result } = useMutation({
    mutationFn: (variables: Download) => FileApi.downloadFile(variables),
  });

  return { fileDownload, ...result };
};
